export type Action = {
  readonly type: string;
  readonly payload?: any;
};

export const setBrands = (brands: string[]): Action => ({
  type: InitialFilterActionsType.SET_BRANDS as InitialFilterActionsType.SET_BRANDS,
  payload: brands,
});

export const setYears = (years: number[]): Action => ({
  type: InitialFilterActionsType.SET_YEARS as InitialFilterActionsType.SET_YEARS,
  payload: years,
});

export const setModels = (models: string[]): Action => ({
  type: InitialFilterActionsType.SET_MODELS as InitialFilterActionsType.SET_MODELS,
  payload: models,
});

export const setTrims = (trims: string[]): Action => ({
  type: InitialFilterActionsType.SET_TRIMS as InitialFilterActionsType.SET_TRIMS,
  payload: trims,
});

export const setExtColor = (extColor: string[]): Action => ({
  type: InitialFilterActionsType.SET_EXT_COLOR as InitialFilterActionsType.SET_EXT_COLOR,
  payload: extColor,
});

export const setAgeDays = (ageDays: { min: number; max: number }): Action => ({
  type: InitialFilterActionsType.SET_AGE_DAYS as InitialFilterActionsType.SET_AGE_DAYS,
  payload: ageDays,
});

export const setMileage = (mileage: { min: number; max: number }): Action => ({
  type: InitialFilterActionsType.SET_MILEAGE as InitialFilterActionsType.SET_MILEAGE,
  payload: mileage,
});

export const setPrice = (price: { min: number; max: number }): Action => ({
  type: InitialFilterActionsType.SET_PRICE as InitialFilterActionsType.SET_PRICE,
  payload: price,
});

export const setIntColor = (intColor: string[]): Action => ({
  type: InitialFilterActionsType.SET_INT_COLOR as InitialFilterActionsType.SET_INT_COLOR,
  payload: intColor,
});

export const resetFilter = (): Action => ({
  type: InitialFilterActionsType.RESET_FILTER as InitialFilterActionsType.RESET_FILTER,
});

export enum InitialFilterActionsType {
  SET_YEARS = '[FILTER] Years Set',
  SET_MODELS = '[FILTER] Models Set',
  SET_TRIMS = '[FILTER] Trims Set',
  SET_BRANDS = '[FILTER] Brands Set',
  SET_EXT_COLOR = '[FILTER] Exterior Color Set',
  SET_INT_COLOR = '[FILTER] Interior Color Set',
  RESET_FILTER = '[FILTER] Reset',
  SET_AGE_DAYS = '[FILTER] Age Days Set',
  SET_MILEAGE = '[FILTER] Mileage Set',
  SET_PRICE = '[FILTER] Price Set',
}

export type InitialFilterActions = ReturnType<
  | typeof setYears
  | typeof setModels
  | typeof setTrims
  | typeof setBrands
  | typeof setExtColor
  | typeof setIntColor
  | typeof resetFilter
  | typeof setAgeDays
  | typeof setMileage
  | typeof setPrice
>;
